export default {
  name: "BeforeAfterBreadcrumbs",

  props: {
    current: {
      type: String,
      default: null,
    },
  },
};
